/* eslint-disable import/no-unresolved */
import { MatxLoadable } from "matx";

const CreateVehicles = MatxLoadable({
  loader: () => import("../views/vehicles"),
});

const VehicleDetail = MatxLoadable({
  loader: () => import("../views/vehicles/vehicleDetails"),
});

const AlarmVehicles = MatxLoadable({
  loader: () => import("../views/vehicles/alarmVehicles"),
});

const vehicleRoutes = [
  {
    path: "/vehicles/list/:id",
    component: VehicleDetail,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/vehicles/dashboard",
    component: CreateVehicles,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/vehicles/list",
    component: CreateVehicles,
    permission: ["manager", "account_holder", "customer_service"],
  },
  {
    path: "/vehicles/alarm",
    component: AlarmVehicles,
    permission: ["manager", "account_holder", "customer_service"],
  },
];

export default vehicleRoutes;
